// twinkling sky
for (const id of ['sky','sky2']) {
  const s = document.getElementById(id);
  for (let i = 0; i < 60; i++) {
    const d = document.createElement('i');
    d.style.left = Math.random()*100+'%'; d.style.top = Math.random()*100+'%';
    d.style.animationDelay = (Math.random()*3)+'s'; d.style.animationDuration = (2+Math.random()*3)+'s';
    s.appendChild(d);
  }
}
// sparkles over the cover's night sky (top 40% of the art)
const fx = document.getElementById('fx');
if (fx) for (let i = 0; i < 14; i++) {
  const st = document.createElement('div'); st.className = 'st';
  st.style.left = (5+Math.random()*90)+'%'; st.style.top = (2+Math.random()*36)+'%';
  st.style.animationDelay = (Math.random()*2.4)+'s';
  const z = 4+Math.random()*6; st.style.width = st.style.height = z+'px';
  fx.appendChild(st);
}
// reveal on scroll
const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), {threshold:.15});
document.querySelectorAll('.reveal').forEach((el,i) => { el.style.transitionDelay = (i%4)*80+'ms'; io.observe(el); });
// carousel buttons
const tr = document.getElementById('track');
document.querySelectorAll('.track-nav button').forEach(b => b.onclick = () => tr.scrollBy({left: b.dataset.d*420, behavior:'smooth'}));
// click-to-load video (self-hosted, nothing downloads until played)
const yt = document.getElementById('yt');
const play = () => {
  if (yt.querySelector('video')) return;
  yt.onclick = yt.onkeydown = null; yt.removeAttribute('role'); yt.removeAttribute('tabindex'); yt.removeAttribute('aria-label');
  yt.innerHTML = '<video src="' + yt.dataset.src + '" poster="' + yt.querySelector('img').src + '" controls autoplay playsinline title="Tiny Walkers Busy Book video"></video>';
  yt.querySelector('video').focus();
};
yt.onclick = play; yt.onkeydown = e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); } };
// set options
const price = document.getElementById('price'), was = document.getElementById('was');
document.querySelectorAll('.buy-form input[name=id]').forEach(r => r.onchange = () => {
  price.textContent = r.dataset.price; was.textContent = r.dataset.was;
  const add = r.dataset.addon, cov = document.querySelector('.cover'), box = document.getElementById('addon');
  if (cov && box) {
    if (add) {
      const both = add.includes('-'), im = box.querySelector('img');
      im.removeAttribute('srcset'); // srcset would override the swapped src
      im.src = im.dataset[both ? 'animals' : add] || im.src;
      box.classList.toggle('both', both);
      document.getElementById('addon-cap').textContent = both ? '+ both memory games' : '+ ' + add.charAt(0).toUpperCase() + add.slice(1) + ' memory game';
    }
    cov.classList.toggle('with-addon', !!add);
  }
  document.querySelector('.mbuy b').textContent = r.dataset.price;
});
// memory game flipbook, plays only while on screen
// frames download only when the game first comes near the screen
const flip = document.getElementById('flip'), urls = flip.dataset.frames.split(','), N = urls.length, ms = flip.dataset.timing.split(',').map(Number);
let frames = null, fi = -1, timer = null;
const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
const step = () => { fi = (fi + 1) % N; if (frames[fi].complete) flip.src = frames[fi].src; timer = setTimeout(step, ms[fi] || 380); };
if (!still) new IntersectionObserver(es => {
  if (es[0].isIntersecting) {
    frames ??= urls.map(u => { const im = new Image(); im.src = u; return im; });
    if (!timer) timer = setTimeout(step, 400);
  } else { clearTimeout(timer); timer = null; }
}, {rootMargin: '300px 0px'}).observe(flip);
// mobile buy bar after hero
const mb = document.getElementById('mbuy');
// hidden while the hero or the footer is on screen, so it never covers the footer links
let heroIn = true, footIn = false;
const mbSync = () => mb.classList.toggle('show', !heroIn && !footIn);
new IntersectionObserver(es => { heroIn = es[0].isIntersecting; mbSync(); }).observe(document.querySelector('.hero'));
const foot = document.querySelector('footer');
if (foot) new IntersectionObserver(es => { footIn = es[0].isIntersecting; mbSync(); }).observe(foot);

// scroll effects
(() => {
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. pages fan out
  const track = document.getElementById('track');
  if (track && !still) {
    track.querySelectorAll('.pg').forEach((p, i) => p.style.setProperty('--i', Math.min(i, 8)));
    track.classList.add('fx-wait');
    new IntersectionObserver((es, o) => {
      if (!es[0].isIntersecting) return;
      track.classList.replace('fx-wait', 'fx-go');
      o.disconnect();
    }, {threshold: .25}).observe(track);
  }

  // 3. velcro dots on headings
  const cols = ['var(--tomato)', 'var(--sun)', 'var(--grass)', 'var(--pink)', '#4b9be0'];
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), {threshold: 1});
  document.querySelectorAll('main h2, section h2').forEach((h, n) => {
    const d = document.createElement('span');
    d.className = 'dots'; d.setAttribute('aria-hidden', 'true');
    for (let k = 0; k < 3; k++) {
      const i = document.createElement('i');
      i.style.setProperty('--c', cols[(n + k) % cols.length]);
      i.style.setProperty('--k', k);
      d.appendChild(i);
    }
    // glue dots to the last word so they never wrap alone
    const t = [...h.childNodes].reverse().find(x => x.nodeType === 3 && x.textContent.trim());
    if (t) {
      const m = t.textContent.match(/^([\s\S]*?)(\S+)(\s*)$/);
      const w = document.createElement('span'); w.className = 'nw';
      w.append(m[2], d);
      t.textContent = m[1];
      t.after(w);
    } else h.appendChild(d);
    io.observe(d);
  });
})();

// parallax
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const hero = document.querySelector('.hero');
  const sky = document.getElementById('sky');
  const vis = document.querySelector('.hero .hero-visual');
  const fin = document.querySelector('.final'), sky2 = document.getElementById('sky2');
  const wide = matchMedia('(min-width: 900px)');
  let on = true, ticking = false;
  new IntersectionObserver(es => { on = es[0].isIntersecting; }).observe(hero);
  const run = () => {
    ticking = false;
    const y = scrollY;
    if (on) {
      sky.style.translate = `0 ${y * .45}px`;
      vis.style.translate = wide.matches ? `0 ${y * .18}px` : '';
    }
    if (fin && sky2) {
      const r = fin.getBoundingClientRect();
      if (r.top < innerHeight && r.bottom > 0) sky2.style.translate = `0 ${(r.top - innerHeight / 2) * -.25}px`;
    }
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, {passive: true});
  run();
})();
